import type { BaseKeyFunction } from "../../../lib";

export const keyPromoCode: BaseKeyFunction = () => ["promocode"];
